module.exports = __webpack_public_path__ + "img/wholesaleIcon9.20dd5ad5.png";